import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { StudentLayout } from './components/layouts/StudentLayout';
import { AdminLayout } from './components/layouts/AdminLayout';
// Student Pages
import { StudentHome } from './pages/student/Home';
import { StudentHallOfFame } from './pages/student/HallOfFame';
import { StudentProfile } from './pages/student/Profile';
// Admin Pages
import { AdminDashboard } from './pages/admin/Dashboard';
import { StudentDetail } from './pages/admin/StudentDetail';
import { HallOfFameAdmin } from './pages/admin/HallOfFameAdmin';
import { AdminSettings } from './pages/admin/Settings';
export function App() {
  useEffect(() => {
    document.title = 'Iron Gym';
  }, []);
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Landing data-id="element-3" />} data-id="element-2" />

        {/* Student Routes */}
        <Route path="/student" element={<StudentLayout data-id="element-5" />} data-id="element-4">
          <Route path="home" element={<StudentHome data-id="element-7" />} data-id="element-6" />
          <Route path="hall-of-fame" element={<StudentHallOfFame data-id="element-9" />} data-id="element-8" />
          <Route path="profile" element={<StudentProfile data-id="element-11" />} data-id="element-10" />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout data-id="element-13" />} data-id="element-12">
          <Route path="dashboard" element={<AdminDashboard data-id="element-15" />} data-id="element-14" />
          <Route path="student/:id" element={<StudentDetail data-id="element-17" />} data-id="element-16" />
          <Route path="hall-of-fame" element={<HallOfFameAdmin data-id="element-19" />} data-id="element-18" />
          <Route path="settings" element={<AdminSettings data-id="element-21" />} data-id="element-20" />
        </Route>
      </Routes>
    </Router>;
}